import comp from "./JobView";
export default comp;
